<!--
 * @Description: 医生端登录
 * @Date: 2019-10-24 10:58:17
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-05 14:52:20
 -->
<template>
  <div class="Login">
    <v-card class="mx-auto" height="294" max-width="344" min-width="344">
      <v-card-text>
        <div>登录</div>
        <p class="display-1 text--primary">WELCOME!</p>
        <p>健康很难,硬汉邦帮你</p>
        <div class="text--primary" style="padding-left: 0;padding-right: 0;" >
          <v-col cols="12" sm="12" md="12">
            <v-text-field label="手机号码" outlined color="black" v-mask="mask" v-model="value"></v-text-field>
            <v-btn text color="deep-purple accent-4" v-show="!time_S" @click="VerificationCode">获取验证码</v-btn>
            <v-expand-x-transition>
              <v-btn text color="deep-purple accent-4" v-show="time_S" disabled >{{time}}秒后重新获取</v-btn>
            </v-expand-x-transition>
          </v-col>
        </div>
        <v-row justify="center">
          <div class="mx-4 hidden-sm-and-down"></div>
          <v-col class="shrink code_" min-width="344">
            <v-expand-x-transition  >
              <v-card v-show="expand2" height="294" width="344" class="mx-auto">
                <p class="display-1 text--primary code_text_" style="" >输入验证码!</p>
                <p class="code_text__" >验证码已通过短信发送至 {{ value }}</p>
                <v-text-field label="验证码" outlined rounded color="black code_code" style="width: 290px;margin-left: 25px;" v-mask="mask_" v-model="code_value" @input="login" ></v-text-field>
                <v-btn text color="deep-purple accent-4" style="margin-left: 25px;" @click="expand2 = !expand2">重新输入手机</v-btn>
              </v-card>
            </v-expand-x-transition>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { mask } from "vue-the-mask";
export default {
  name: "home",
  directives: {
    mask
  },
  components: {
    // HelloWorld
  },
  data: () => ({
    mask: "###-####-####",
    mask_: "####",
    value: "",
    code_value:'',
    submitStatus: false,
    expand2: false,
    time_S: false,
    time: 60
  }),
  methods: {
    /* 验证输入/倒计时 */ 
    VerificationCode(){
      if( this.value.length !== 13 ){
        this.$Dialog.getProductCheckResult_({text: `请输入有效的手机号码！`,timeout: 3000, snackbar: true });
        return false
      }
      if( this.time == 60 ){this.timeFun();}
      this.submit();
    },
    timeFun() {
        if (this.time == 0) {
            this.time = 60;
            this.time_S = false;
        } else {
            this.time--;
            setTimeout(()=>{
                    this.timeFun(this.time);
            }, 1000)
        }
    },
    /* 验证码 */
    submit(){
      this.$axios({
        method: "post",
        url: this.$apis.URL.user_phone_code,
        data: {
          phone: this.value.split('-').join('')
        }
      })
        .then((req) => {
          if(req.data.result == 0){
            this.time_S = true;
            setTimeout(()=>{ this.expand2 = true; },500);
            this.$Dialog.getProductCheckResult_({text: `验证码已发送到 ${ this.value }`,timeout: 3000, snackbar: true });
          }else{
            this.$Dialog.getProductCheckResult_({text: req.data.message,timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({text: error,timeout: 3000, snackbar: true });
        });
    },
    /* 登录 */
    login(){
      if( this.code_value.length !== 4 ){
        return false;
      }
      this.$Dialog.getProductCheckResult_({text: `正在登录 ${ this.value }`,timeout: 3000, snackbar: true });
      this.$axios({
        method: "post",
        url: this.$apis.URL.doctor_login,
        data: {
          phone: this.value.split('-').join(''),
          code: this.code_value
        }
      })
        .then((req) => {
          if(req.data.result == 0){
            setTimeout(()=>{
              this.$Dialog.getProductCheckResult_({text: `登录成功，欢迎回来！`,timeout: 3000, snackbar: true });
              switch (req.data.datas.pass_validation) {
                case 1:
                  this.$router.push({
                    path: `/SubmitReview`,
                    query: {
                      pass_validation: req.data.datas.pass_validation
                    }
                  });
                  break;
                  case 2:
                  this.$router.push({
                    path: `/SubmitReview`,
                    query: {
                      pass_validation: req.data.datas.pass_validation,
                      time: req.data.datas.update_time,
                      switch: false
                    }
                  });
                  break;
                  case 3:
                  this.$router.push({
                    path: `/SubmitReview`,
                    query: {
                      pass_validation: req.data.datas.pass_validation,
                      switch: true,
                      rejection_reason: req.data.datas.rejection_reason,
                      time: req.data.datas.update_time
                    }
                  });
                  break;
                  case 4:
                  this.$router.push({
                    path: `/home`,
                    query: {}
                  });
                  break;
                default:
                  break;
              }
            },600)
          }else{
            this.$Dialog.getProductCheckResult_({text: req.data.message,timeout: 3000, snackbar: true });
          }
        })
        .catch(error => {
          this.$Dialog.getProductCheckResult_({text: error,timeout: 3000, snackbar: true });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.Login {
  margin-top: 10%;
  position: relative;
}
.code_ {
  padding: 0;
  position: absolute;
  top: 0;
}
.code_text_{
  padding-left: 20px;
  padding-top: 40px;
  white-space: nowrap;
}
.code_text__{
  padding-left: 20px;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 28px;
  white-space: nowrap;
}
.code_code{
  margin-left: 10px;
}
</style>


